import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { MODAL_TYPE_PRO_MYPAGE_DELETE, MODAL_TYPE_PRO_MYPAGE_DESTINATION, MODAL_TYPE_PRO_MYPAGE_REPRESENTATIVE, showModal, } from '../../../../../../../actions/ModalActions';
import { apiUpdateProfessionalSolutionAcceptance, toggleOrdersOfProfessionalMySolution, } from '../../../../../../../actions/ProfessionalMySolutionActions';
import { propFunc, propShape, } from '../../../../../../../helpers/custom-prop-types';
import { compose } from '../../../../../../../helpers/recompose';
import { isEnableAcceptanceChange } from '../../../../../../../helpers/solution';
import BalloonCategoryPrice from '../../../../../../Ui/Solution/BalloonCategoryPrice';
import ChangeAcceptance from '../../../HeaderParts/ChangeAcceptance';
import DetailContact from '../../../HeaderParts/DetailContact';
import OverViewManager from '../../../HeaderParts/OverViewManager';
import OverViewMenu from '../../../HeaderParts/OverViewMenu';
import OverViewThumbnail from '../../../HeaderParts/OverViewThumbnail';
const ProfessionalMyPageTopMySolutionItemHeader = (props) => {
    const { item, profile, showModalChangeDestination, showModalChangeRepresentative, showModalDeleteSolution, toggleOrders, updateAcceptance, } = props;
    const { solution } = item;
    const history = useNavigate();
    return (_jsxs("div", Object.assign({ className: 'my-solution-overview' }, { children: [_jsx(OverViewThumbnail, { solution: solution }), _jsxs("div", Object.assign({ className: 'overview-title' }, { children: [_jsx("h4", { children: _jsx(Link, Object.assign({ target: '_blank', to: `/solutions/${solution.id}${solution.status === 4 ? '' : '?preview=on'}` }, { children: solution.title })) }), _jsx(BalloonCategoryPrice, { isOneElement: true, item: solution })] })), _jsx(OverViewManager, { profile: profile, showModal: showModalChangeRepresentative, solution: solution }), _jsx(ChangeAcceptance, { disabled: !isEnableAcceptanceChange(solution, profile), onChange: updateAcceptance, solution: solution }), _jsx(DetailContact, { onClick: toggleOrders, orders: item.orders || [] }), _jsx(OverViewMenu, { history: history, profile: profile, showModalChangeDestination: showModalChangeDestination, showModalDeleteSolution: showModalDeleteSolution, solution: solution })] })));
};
ProfessionalMyPageTopMySolutionItemHeader.propTypes = {
    item: propShape().isRequired,
    profile: propShape().isRequired,
    showModalChangeDestination: propFunc().isRequired,
    showModalChangeRepresentative: propFunc().isRequired,
    showModalDeleteSolution: propFunc().isRequired,
    toggleOrders: propFunc().isRequired,
    updateAcceptance: propFunc().isRequired,
};
const mapDispatchToProps = (dispatch, { item: { solution } }) => ({
    showModalChangeDestination: () => {
        dispatch(showModal(MODAL_TYPE_PRO_MYPAGE_DESTINATION, solution.id, { solution }));
    },
    showModalChangeRepresentative: () => {
        dispatch(showModal(MODAL_TYPE_PRO_MYPAGE_REPRESENTATIVE, solution.id, {
            solution,
        }));
    },
    showModalDeleteSolution: () => {
        dispatch(showModal(MODAL_TYPE_PRO_MYPAGE_DELETE, solution.id, { solution }));
    },
    toggleOrders: () => {
        dispatch(toggleOrdersOfProfessionalMySolution(solution.id, { solution }));
    },
    updateAcceptance: (event) => {
        const acceptance = parseInt(event.target.value, 10);
        dispatch(apiUpdateProfessionalSolutionAcceptance(solution.id, { acceptance }));
    },
});
const enhance = compose(connect(null, mapDispatchToProps));
export default enhance(ProfessionalMyPageTopMySolutionItemHeader);
